export class DiagnosisModel {
    code = '';
    level = '';
    name = '';
    name_en = '';
    parent_id = '';
    is_proposal = 0;
}